<div class="notification-view">
    <div class="notification-icon">
        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <title>0390F871-EAAE-4A15-94CF-FA48DD3797A2</title>
            <g id="Pop-up-Notification" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g transform="translate(-48.000000, -2775.000000)" id="Notication">
                    <g transform="translate(24.000000, 2751.000000)">
                        <g id="checkmark-circle" transform="translate(24.000000, 24.000000)">
                            <circle id="Oval" fill="#000000" cx="12" cy="12" r="12"></circle>
                            <g id="checkmark" transform="translate(6.000000, 6.000000)">
                                <rect id="Rectangle" x="0" y="0" width="12" height="12"></rect>
                                <polyline id="Stroke-3" stroke="#FFFFFF" stroke-width="3" points="1 6 4.5 9 10.5 2"></polyline>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    </div>
    <div class="notification-text">
        {{notificationText}}
    </div>
</div>